import { reconciliationQueuePtBr } from './reconciliation-queue';

export const reconciliationPtBr = {
  queue: reconciliationQueuePtBr,
  draftRecovery: {
    discard: 'Descartar rascunho',
    description:
      'Os vínculos e ajustes deste rascunho serão removidos. As transações bancárias serão preservadas e você poderá selecionar outra contraparte.',
    discarded: 'Rascunho descartado. Selecione a contraparte para conciliar.',
  },
  bankAccountMappingRecovery: {
    message:
      'Para concluir a conciliação, configure a conta de sistema “Contas Bancárias” na versão vigente do plano de contas.',
    title: 'Como resolver',
    instructions:
      'No mapeamento de contas de sistema, localize “Contas Bancárias” e vincule a conta contábil correspondente.',
    action: 'Configurar Contas Bancárias',
    bankAccountAction: 'Configurar conta bancária',
  },
  transferValidation: {
    BANK_LEG_AMOUNT_MISMATCH_REQUIRES_ACCOUNTING:
      'As movimentações têm valores diferentes. Confira a contraparte e informe os encargos identificados no extrato, com o tipo e a ponta da cobrança.',
    TRANSFER_CHARGE_CLASSIFICATION_REQUIRED:
      'Selecione a conta gerencial do encargo antes de conciliar. Tarifas, IOF e IRRF definitivo são despesas.',
    TRANSFER_CHARGE_CLASSIFICATION_INVALID:
      'Revise a classificação do encargo. As dimensões devem estar ativas e pertencer à mesma entidade; a conta gerencial deve ser uma conta folha, válida na data do encargo e compatível com despesa ou imposto a recuperar.',
    TRANSFER_CHARGE_SIDE_REQUIRED: 'Indique em qual ponta da transferência o encargo foi cobrado.',
    TRANSFER_CHARGE_FX_EVIDENCE_REQUIRED:
      'Este lançamento exige valores na moeda funcional do livro. Configure a moeda ou use um fluxo com evidência de conversão cambial.',
    TRANSFER_CHARGE_JURISDICTION_MISMATCH:
      'IOF e IRRF são tributos brasileiros. Confira o país da entidade e o tipo de encargo.',
    TRANSFER_CHARGE_AMOUNT_INVALID:
      'O valor ou o sinal do encargo não corresponde à transferência. Confira a saída, a entrada e os ajustes.',
    TRANSFER_CHARGE_AMOUNT_MISMATCH:
      'A saída deve ser igual à entrada mais os encargos informados. Confira os valores do extrato.',
    TRANSFER_CHARGE_TYPE_UNSUPPORTED:
      'Esta transferência aceita tarifa bancária e, para entidades brasileiras, IOF ou IRRF. Não crie uma conta a pagar adicional para o mesmo encargo.',
    TRANSFER_CHARGE_ATTRIBUTION_REQUIRED:
      'Identifique a transferência de cada encargo. Concilie um par de movimentações por vez.',
    TRANSFER_CHARGE_PARTIAL_NOT_SUPPORTED:
      'Concilie os valores integrais das duas pontas para contabilizar os encargos. A alocação parcial não é suportada neste fluxo.',
    TRANSFER_CHARGE_EXISTING_POSTING:
      'Uma das pontas já tem lançamento contábil. Revise ou desfaça esse lançamento antes de acrescentar encargos.',
    TRANSFER_CHARGE_POSTING_FAILED:
      'Não foi possível contabilizar os encargos. A conciliação não foi confirmada. Confira os mapeamentos contábeis e o período.',
    TAX_REGIME_NOT_CONFIGURED:
      'Configure o regime fiscal da entidade para determinar o tratamento do IRRF.',
    TRANSFER_MOVEMENT_NOT_FOUND:
      'Uma das transações não está mais disponível. Atualize a conciliação e selecione a outra ponta novamente.',
    TRANSFER_MOVEMENT_INELIGIBLE:
      'Uma das pontas não está mais disponível para conciliação. Atualize a lista e selecione movimentações postadas, não duplicadas e ainda abertas.',
    TRANSFER_PARTIAL_ALLOCATION_NOT_SUPPORTED:
      'Concilie o valor integral da contraparte. A alocação parcial não é suportada neste fluxo.',
    TRANSFER_SAME_ACCOUNT:
      'Selecione uma transação de outra conta bancária para conciliar esta transferência.',
    TRANSFER_SAME_DIRECTION:
      'A transferência precisa de uma saída e uma entrada. Selecione uma transação com direção oposta.',
    TRANSFER_DIFFERENT_ENTITY: 'As contas da transferência devem pertencer à mesma entidade.',
    TRANSFER_DISCOUNT_NOT_ALLOWED:
      'Desconto não se aplica a transferências entre contas. Remova o desconto e confira as duas pontas e os encargos identificados no extrato.',
  },
  transferDifference: {
    managerialAccount: 'Conta gerencial',
    costCenter: 'Centro de custo (opcional)',
    department: 'Departamento (opcional)',
    classificationRequired: 'Selecione a conta gerencial da despesa.',
    irrfClassification:
      'IRRF definitivo exige conta gerencial de despesa. Para IRRF a recuperar, deixe em branco ou selecione uma conta gerencial de ativo.',

    message:
      'Diferença de {{amount}} entre as pontas. Confira se as transações são da mesma transferência. Informe apenas encargos identificados no extrato e indique a ponta da cobrança. Tributos brasileiros dependem do país e do regime fiscal da entidade.',
    investmentIrrf: 'IRRF sobre investimentos',
    chargeSide: 'Ponta da cobrança',
    chooseSide: 'Selecione a ponta da cobrança',
    debitSide: 'Conta de saída (débito)',
    creditSide: 'Conta de entrada (crédito)',
    enterCharge: 'Informar encargo ou imposto',
  },
  statutoryPaymentAllocation: {
    title: 'Distribuir pagamento tributário',
    previewTitle: 'Saldos do pagamento tributário',
    readOnly: 'Consulte o saldo de cada componente.',
    choose: 'Informe quanto quitar de cada componente.',
    confirm: 'Confira os valores antes de conciliar.',
    loading: 'Carregando saldos...',
    applying: 'Conciliando pagamento...',
    success: 'Pagamento conciliado.',
    close: 'Ver conciliação',
    payment: 'Pagamento {{count}} · {{amount}}',
    remaining: 'Em aberto: {{amount}}',
    document: 'Guia',
    PRINCIPAL: 'Principal',
    FINE: 'Multa',
    INTEREST: 'Juros',
    invalid: 'Distribua o valor total do pagamento sem ultrapassar o saldo de cada componente.',
    changed: 'O saldo mudou. Atualize os saldos e confira os valores novamente.',
    permission:
      'É necessário gerenciar Contabilidade e ter acesso a Operações para consultar estes saldos.',
    failed: 'Não foi possível conciliar. Seus valores foram preservados.',
    cancel: 'Cancelar',
    back: 'Voltar',
    continue: 'Conferir valores',
    apply: 'Confirmar e conciliar',
    retry: 'Tentar novamente',
    refresh: 'Atualizar saldos',
  },
  common: {
    cancel: 'Cancelar',
    saving: 'Salvando...',
    // ALC-4327 (BT-5): the "Cancelar reconciliação" dialog read this key and showed it raw.
    loading: 'Carregando...',
    moreActions: 'Mais ações',
  },
  /**
   * ALC-4327 (UI-2): the in-dialog state of a refused undo. `CancelReconciliationDialog` reads
   * `cancelPosted.*` at the top level of this namespace (the older `inbox.cancelPosted` block is not
   * the path it reads), so the two new keys live here.
   */
  cancelPosted: {
    retry: 'Tentar novamente',
    close: 'Fechar',
  },
  /** App chrome: matches `appShell.routes.titles.reconciliationReview` (inbox → review trail). */
  reviewRoute: {
    pageTitle: 'Revisar conciliação',
  },
  review: {
    main: {
      suggestions: 'Sugestões de conciliação',
    },
    footer: {
      transaction: 'Transação',
      accounts: 'Contas',
      adjustments: 'Ajustes',
      difference: 'Diferença',
      partialPayment: 'Pagamento parcial',
      partialRemaining: 'Saldo restante',
      reconcilePartial: 'Confirmar conciliação (parcial)',
      back: 'Voltar',
      vendorAdvanceSemConta: 'Adiantamento (sem conta)',
    },
    vendorAdvanceHighlight: {
      title: 'Adiantamento a fornecedor',
      subtitle:
        'Ajuste de adiantamento — o valor será conciliado ao fornecedor sem conta a pagar pré-existente.',
      subtitleBill:
        'Conta a pagar do tipo adiantamento criada — confira o valor e finalize a conciliação.',
      fullAmountBadge: 'Valor integral da transação',
      vendorLabel: 'Fornecedor',
      amountLabel: 'Valor',
      removeAria: 'Remover adiantamento',
    },
    header: {
      statusReconciled: 'Conciliado',
      statusDifference: 'Diferença',
      statusAwaitingPair: 'Aguardando par',
    },
    txAnchor: {
      cardItemLabel: 'Item de cartão',
      transactionLabel: 'Transação bancária',
      select: 'Selecione',
      balanced: 'Conciliado',
      matchedAmount: '= {{amount}}',
      missing: 'Faltam',
      exceeds: 'Excede',
      linkedAccounts: 'Contas vinculadas',
      reconciliation: 'Conciliação',
      vendor: 'Fornecedor',
      vendorAdvanceReceipt: 'Recebimento de adiantamento a fornecedor - {{vendorName}}',
      loading: 'Carregando detalhes da conciliação',
      selectBelow: 'Selecione abaixo',
      adjustments: 'ajustes',
      linkedCountLabelOne: '1 conta',
      linkedCountLabel: '{{count}} contas',
      billFxInline: 'câmbio {{rate}}',
      exchangeInline: 'câmbio {{rate}}',
      adjustmentShort: 'ajuste',
    },
    embedded: {
      dueShort: 'Venc.',
      paidShort: 'Pago',
      scheduledShort: 'Agend.',
      issueShort: 'Emissão',
      managerialShort: 'Ger.',
      postedShort: 'Post.',
      effectiveShort: 'Efet.',
      dataShort: 'Data',
      openAccount: 'Abrir conta',
      exchangeRate: 'Câmbio {{rate}}',
    },
    reconciledLayout: {
      linkedAccountsTitle: 'Contas vinculadas',
      linkedAccountsMeta: '{{count}} contas · subtotal {{subtotal}}',
      adjustmentsTitle: 'Ajustes',
      adjustmentsTotal: 'Total',
    },
    selectedSummary: {
      totalMatch: 'Total do match:',
      expand: 'Expandir seleção ({{count}})',
      dialogTitle: 'Contas e ajustes selecionados',
      dialogDescription: '{{count}} itens selecionados. Remova itens aqui para atualizar o match.',
      removeItem: 'Remover {{name}}',
      removeAdjustment: 'Remover ajuste {{type}}',
      unconditionalDiscountRecovery:
        'Este ajuste baixa o contas a receber e mantém sua classificação contábil, mas não reduz novamente a base de PIS/COFINS. Se a receita registrada estiver incorreta, corrija a fatura e seu documento de origem pelo fluxo de correção.',
    },
  },
  workbench: {
    title: 'Workbench de Conciliação',
    subtitle: 'Selecione e vincule transações com suas contas a pagar e realize ajustes.',
    confirm: 'Confirmar Conciliação',
    total: 'Total',
    difference: 'Diferença',
    balanced: 'Conciliação balanceada',
    notBalanced: 'Adicione ajustes ou itens para balancear',
    origins: {
      title: 'Origens',
      description: 'Transações bancárias e cartões',
      empty: 'Nenhuma transação selecionada. Selecione itens da lista de conciliação.',
    },
    targets: {
      title: 'Destinos',
      description: 'Contas a pagar, receber e transferências',
      empty: 'Nenhum destino selecionado. Adicione contas a pagar ou receber.',
    },
    matching: {
      title: 'Conciliação',
      description: 'Resumo e ajustes financeiros',
    },
    adjustments: {
      title: 'Ajustes Financeiros',
      add: 'Adicionar Ajuste',
      empty: 'Nenhum ajuste adicionado',
    },
    error: {
      notBalanced: 'A diferença de R$ {{difference}} deve ser zero para confirmar',
      failed: 'Falha ao confirmar conciliação',
    },
    success: {
      created: 'Conciliação criada com sucesso',
    },
    transactionTypes: {
      all: 'Todas',
      debit: 'Saída',
      credit: 'Entrada',
      transfer: 'Transferência',
    },
    internalOp: {
      title: 'Operação interna',
      description:
        'Conciliar como rendimento, resgate ou aplicação (sem vínculo com contas a pagar/receber)',
      confirmButton: 'Conciliar como operação interna',
      success: 'Operação interna conciliada com sucesso',
    },
    internalTransfer: {
      title: 'Transferência entre contas',
      description: 'Vincular as duas transações como transferência entre contas próprias',
      confirmButton: 'Conciliar transferência',
      success: 'Transferência conciliada com sucesso',
      needPair: 'Selecione duas transações (uma saída e uma entrada) do mesmo valor',
    },
    targetTypes: {
      payable: 'A Pagar',
      payroll: 'Folha de pagamento',
      receivable: 'A Receber',
      transfer: 'Transferências',
    },
    filters: {
      all: 'Todas',
      payable: 'A Pagar',
      receivable: 'A Receber',
      transfer: 'Transferências',
    },
    form: {
      adjustmentType: 'Tipo',
      amount: 'Valor',
      amountPlaceholder: '0,00',
      description: 'Descrição',
      descriptionPlaceholder: 'Descrição opcional do ajuste',
      vendorIdFallbackPlaceholder: 'Preenchido pela conta selecionada',
    },
    labels: {
      dueDate: 'Vencimento',
      vendor: 'Fornecedor',
      account: 'Conta',
      toReconcile: 'A Conciliar',
      partialPayment: 'Pagamento Parcial',
    },
    vendorReceipt: {
      menu: 'Registrar recebimento de fornecedor (Saldo)',
      title: 'Registrar recebimento de fornecedor (Saldo)',
      description: 'Baixe o saldo de adiantamento do fornecedor com este crédito bancário.',
      available: 'Saldo disponível',
      receipt: 'Crédito dessa transação ainda não baixado',
      noBalanceWarning:
        'Não é possível registrar o recebimento porque este fornecedor não possui saldo de adiantamento disponível.',
      amount: 'Valor a baixar',
      confirm: 'Confirmar recebimento',
      confirmation: 'Confirme para registrar a baixa no saldo de adiantamentos do fornecedor.',
      remaining: 'Saldo remanescente',
      errorCandidates: 'Não foi possível carregar os fornecedores elegíveis.',
      errorAmount: 'Informe um valor maior que zero e limitado ao crédito e ao saldo disponível.',
      error: 'Não foi possível registrar o recebimento.',
      success: 'Recebimento de fornecedor registrado.',
      processingTitle: 'Registrando recebimento',
      processingDescription: 'Aguarde enquanto atualizamos a conciliação e o saldo do fornecedor.',
      successTitle: 'Recebimento registrado',
      errorTitle: 'Não foi possível concluir',
      errorDescription: 'Revise o erro antes de tentar novamente.',
      retry: 'Revisar e tentar novamente',
      close: 'Fechar',
      done: 'Concluir',
      defaultDescription: 'Devolução de adiantamento a fornecedor',
      errors: {
        VENDOR_RECEIPT_REQUIRES_PENDING_CREDIT:
          'Este crédito não está mais pendente para conciliação.',
        VENDOR_RECEIPT_INSUFFICIENT_BALANCE: 'O saldo disponível do fornecedor não é suficiente.',
        VENDOR_RECEIPT_AMOUNT_EXCEEDS_REMAINING_CREDIT:
          'O valor não pode exceder o crédito bancário ainda não baixado.',
        VENDOR_RECEIPT_VENDOR_MISMATCH:
          'Este crédito já foi parcialmente baixado para outro fornecedor. Continue com o fornecedor da primeira baixa.',
        VENDOR_RECEIPT_SOURCE_ALREADY_LINKED:
          'Este crédito já pertence a outra conciliação e não pode receber uma nova baixa.',
        VENDOR_RECEIPT_AMOUNT_INVALID: 'Informe um valor monetário válido.',
      },
    },
    notices: {
      createApBill: 'Conta a pagar será criada',
    },
    transactionCard: {
      ariaLabel: 'Transação {{description}} de {{amount}}',
      selectAria: 'Selecionar transação {{description}}',
      noDescription: 'Sem descrição',
      fields: {
        counterparty: 'Contraparte',
        document: 'Documento',
        classification: 'Classificação',
        paymentMethod: 'Método',
        mcc: 'MCC',
        installment: 'Parcela',
        referenceCode: 'Código de referência',
      },
    },
    transaction: {
      title: 'Transação Bancária',
      titleCard: 'Item de Cartão',
      counterparty: 'Contraparte',
      document: 'Documento',
      amount: 'Valor',
      date: 'Data Transação',
      status: 'Status',
      description: 'Descrição',
      paymentMethod: 'Forma de pagamento',
      classification: 'Classificação',
      referenceCode: 'Código de referência',
      account: 'Conta',
      fromAccount: 'De',
      toAccount: 'Para',
      sameAccount: 'mesma conta',
      mcc: 'MCC',
      installment: 'Parcela',
      noData: 'Sem dados disponíveis',
    },
    loading: 'Carregando workbench...',
    processing: 'Processando...',
    selected: 'selecionada(s)',
    list: {
      originsEmpty: 'Nenhuma transação bancária disponível',
      targetsEmpty: 'Nenhuma conta disponível',
      targetsEmptyCta: 'Nenhuma conta encontrada. Clique em "Criar nova" para adicionar.',
      transfersEmpty:
        'Nenhuma transação de direção oposta em outra conta da mesma entidade corresponde aos filtros atuais. Confira o extrato da outra conta.',
      amountDifference: 'Diferença de valor',
      searchPlaceholder: 'Buscar por fornecedor ou descrição...',
      createTarget: 'Criar Conta a Pagar',
      createTargetPayable: 'Criar Conta a Pagar',
      createTargetReceivable: 'Criar Conta a Receber',
      createTargetTransfer: 'Criar Transferência',
      targetFallbackTitle: 'Conta',
      viewBillTooltip: 'Ver conta',
      viewInNewTab: 'Abrir em nova aba',
      createAdjustmentBill: 'Criar conta para este ajuste',
      adjustmentsEmptyTitle: 'Nenhum ajuste adicionado',
      adjustmentsEmptySubtitle: 'Use o botão "Adicionar ajuste" para incluir ajustes financeiros',
      showingOnly: 'Mostrando apenas',
    },
    quickCreate: {
      title: 'Criar Conta a Pagar',
      titlePayable: 'Criar Conta a Pagar',
      titleTarifa: 'Criar Tarifa',
      titleReceivable: 'Criar Conta a Receber',
      titleTransfer: 'Criar Transferência',
      description: 'Crie uma conta a pagar rapidamente sem sair da reconciliação',
      descriptionPayable: 'Crie uma conta a pagar rapidamente sem sair da reconciliação',
      descriptionTarifa: 'Crie uma tarifa rapidamente sem sair da reconciliação',
      descriptionReceivable: 'Crie uma conta a receber rapidamente sem sair da reconciliação',
      descriptionTransfer: 'Crie uma transferência rapidamente sem sair da reconciliação',
      billTypeLabel: 'Tipo de conta a pagar',
      billTypeNormal: 'Normal',
      billTypeFee: 'Tarifa',
      suggestedByAi: 'sugerido pela IA',
      feeRequiresTransactionHelp: 'Tarifa requer uma transação bancária selecionada.',
      entityLabel: 'Entidade Legal',
      entityPlaceholder: 'Selecione a entidade',
      vendorLabel: 'Fornecedor',
      vendorPlaceholder: 'Selecione ou deixe em branco',
      vendorHelp: 'Opcional. Deixe em branco se o fornecedor não estiver cadastrado.',
      amountLabel: 'Valor',
      dueDateLabel: 'Data de Vencimento',
      descriptionLabel: 'Descrição',
      descriptionPlaceholder: 'Ex: Serviços de consultoria, Material de escritório...',
      create: 'Criar Conta a Pagar',
      createPayable: 'Criar Conta a Pagar',
      createTarifa: 'Criar Tarifa',
      addAsDiscount: 'Adicionar como desconto',
      createReceivable: 'Criar Conta a Receber',
      createTransfer: 'Criar Transferência',
      comingSoon: 'Em breve',
      comingSoonDescription: 'Esta funcionalidade estará disponível em breve.',
      comingSoonMessage:
        'A criação rápida de contas a receber e transferências estará disponível em breve.',
      creating: 'Criando...',
      success: 'Conta a pagar criada com sucesso',
      successFee: 'Tarifa criada com sucesso',
      error: 'Erro ao criar conta a pagar. Verifique os dados e tente novamente.',
      titleVendorAdvance: 'Adiantamento a fornecedor',
      titleVendorAdvanceBulk: 'Adiantamento a fornecedor',
      descriptionVendorAdvance:
        'Crie uma conta a pagar de adiantamento vinculada à transação bancária.',
      descriptionVendorAdvanceCard:
        'Crie uma conta a pagar de adiantamento vinculada ao lançamento do cartão.',
      descriptionVendorAdvanceBulk:
        'Crie contas a pagar de adiantamento vinculadas aos lançamentos selecionados do cartão.',
      successVendorAdvance: 'Adiantamento criado com sucesso',
      successVendorAdvanceBulk_one: '{{count}} adiantamento criado com sucesso',
      successVendorAdvanceBulk_other: '{{count}} adiantamentos criados com sucesso',
      errorVendorAdvance: 'Erro ao criar adiantamento. Verifique os dados e tente novamente.',
      errorVendorAdvanceBulk_one: '{{count}} adiantamento com erro',
      errorVendorAdvanceBulk_other: '{{count}} adiantamentos com erro',
      bulkSummary_one: '{{count}} lançamento selecionado',
      bulkSummary_other: '{{count}} lançamentos selecionados',
      bulkTotalAmount: 'Total: {{amount}}',
      createVendorAdvance: 'Criar adiantamento',
      createVendorAdvanceBulk: 'Criar {{count}} adiantamentos',
      descriptionPlaceholderVendorAdvance: 'Ex: Adiantamento para projeto…',
      descriptionPlaceholderVendorAdvanceBulk:
        'Opcional — se vazio, usa o nome do estabelecimento de cada lançamento',
      errors: {
        entityRequired: 'Selecione uma entidade',
        amountRequired: 'Informe um valor válido',
        dueDateRequired: 'Informe a data de vencimento',
        descriptionRequired: 'Informe uma descrição',
        vendorRequired: 'Selecione um fornecedor',
        feeRequiresTransaction: 'Tarifa requer uma transação bancária vinculada.',
        originRequired: 'Origem da transação não informada',
        // Stable API codes, read by code. Nothing is saved on either.
        FEE_BILL_AMOUNT_EXCEEDS_MOVEMENT:
          'O valor da tarifa é maior que o valor da transação. Informe um valor até o valor da transação.',
        VENDOR_ADVANCE_AMOUNT_EXCEEDS_ORIGIN:
          'O valor do adiantamento é maior que o valor da transação. Informe um valor até o valor da transação.',
      },
    },
    quickCreateTransfer: {
      originAccount: 'Conta de origem',
      originPlaceholder: 'Selecione a conta de saída',
      destinationAccount: 'Conta de destino',
      destinationPlaceholder: 'Selecione a conta de entrada',
      dateLabel: 'Data',
      paymentMethod: 'Método de pagamento',
      descriptionPlaceholder: 'Ex: Transferência entre contas, Aplicação...',
      success: 'Transferência criada com sucesso',
      error: 'Erro ao criar transferência. Verifique os dados e tente novamente.',
      errors: {
        originRequired: 'Selecione a conta de origem',
        destinationRequired: 'Selecione a conta de destino',
        sameAccount: 'Conta de origem e destino devem ser diferentes',
        amountRequired: 'Informe um valor válido',
        dateRequired: 'Informe a data da transferência',
        descriptionRequired: 'Informe uma descrição',
      },
    },
    summary: {
      title: 'Resumo da Conciliação',
      totalOrigins: 'Total Origens',
      totalAdjustments: 'Total Ajustes',
      totalTargets: 'Total Destinos',
      difference: 'Diferença',
      targetsLabel: 'Contas Selecionadas',
      partialOf: 'de {{full}}',
      selection: {
        origins: {
          one: '{{count}} origem selecionada',
          other: '{{count}} origens selecionadas',
        },
        targets: {
          one: '{{count}} destino selecionado',
          other: '{{count}} destinos selecionados',
        },
        adjustments: {
          one: '{{count}} ajuste',
          other: '{{count}} ajustes',
        },
      },
    },
    actions: {
      addAdjustment: 'Adicionar Ajuste',
      addAdjustmentTitle: 'Adicionar Ajuste Financeiro',
      addAdjustmentDescription: 'Adicione ajustes financeiros para balancear a conciliação.',
      getSuggestions: 'Buscar Sugestões',
      searchBills: 'Buscar Contas a Pagar',
      searchButton: 'Buscar',
      clearSelection: 'Limpar Seleção',
      confirm: 'Confirmar Conciliação',
      cancel: 'Cancelar',
      selectAll: 'Selecionar todas',
      clearAll: 'Desmarcar todas',
      reconcile: 'Conciliar',
      reconcileSelected: 'Conciliar Selecionados',
      finishAndReturn: 'Concluir e Voltar',
      backToInbox: 'Voltar para Entrada',
      finish: 'Finalizar',
    },
    adjustmentTypes: {
      TARIFA: 'Tarifa',
      ADIANTAMENTO: 'Adiantamento',
      DEVOLUCAO_ADIANTAMENTO: 'Recebimento de fornecedor (saldo)',
      JUROS: 'Juros',
      MULTA: 'Multa',
      DESCONTO: 'Desconto',
      DESCONTO_INCONDICIONAL: 'Desconto incondicional (ajuste contábil)',
      IOF: 'IOF',
      IRRF: 'IRRF',
      PIS: 'PIS',
      COFINS: 'COFINS',
      CSLL: 'CSLL',
      INSS: 'INSS',
      ISS: 'ISS',
      FX: 'Variação Cambial',
      ARREDONDAMENTO: 'Arredondamento',
      IMPOSTOS: 'Impostos retidos',
    },
    allocationModal: {
      title: 'Confirmar alocação',
      description: 'Revise os valores alocados para cada conta antes de confirmar.',
      billColumn: 'Conta',
      originalAmount: 'Valor original',
      allocatedAmount: 'Valor alocado',
      total: 'Total alocado',
      originAmount: 'Valor da transação',
      difference: 'Diferença',
      differenceOk: 'Valores conferem',
      differenceError: 'O total alocado deve ser igual ao valor da transação',
      confirm: 'Confirmar e conciliar',
      cancel: 'Cancelar',
      adjustmentDistributionTitle: 'Distribuição de Multa/Juros',
      discountDistributionTitle: 'Distribuição de Desconto',
      adjustmentTotalExpected: 'Total de multa/juros/desconto',
      adjustmentDifferenceError:
        'A soma deve ser igual ao total de ajustes (diferença: {{amount}})',
    },
    confirmation: {
      title: 'Confirmar Conciliação',
      description:
        'Esta ação irá conciliar os itens selecionados. Esta operação não pode ser desfeita.',
      bankSection: 'Transações Bancárias',
      apSection: 'Contas a Pagar',
      adjustmentsSection: 'Ajustes',
      differenceLabel: 'Diferença final:',
      back: 'Voltar',
      detailsToggle: 'Ver detalhes',
      itemCount: {
        one: '{{count}} item',
        other: '{{count}} itens',
      },
    },
    messages: {
      differenceNotZero: 'A diferença deve ser zero para confirmar',
      partialNotBalanced: 'O valor alocado deve ser igual ao valor da transação',
      partialRemaining: 'A diferença de {{amount}} será mantida em aberto no contas a pagar.',
      remainingToBalance: 'Faltam {{amount}} para bater com o banco',
      remainingToClose: 'Faltam {{amount}} para fechar a conta',
      noItemsSelected: 'Selecione ao menos um item de origem e destino',
      confirmSuccess: 'Conciliação confirmada com sucesso',
      addAdjustmentSuccess: 'Ajuste adicionado com sucesso',
      removeAdjustmentSuccess: 'Ajuste removido com sucesso',
      vendorRequiredForAdvance: 'Selecione o fornecedor para o adiantamento',
      vendorAdvanceSemContaTitle: 'Adiantamento (sem conta)',
      vendorAdvanceSemContaHint:
        'Registra o pagamento como adiantamento ao fornecedor sem vínculo a uma conta a pagar.',
      vendorAdvanceSemContaAdd: 'Adicionar',
      vendorAdvanceSemContaDescriptionPlaceholder: 'Opcional',
      missingSelection:
        'É necessário selecionar ao menos uma origem, um destino e zerar a diferença',
      unbalancedHelp: 'Ajuste os valores para equilibrar a conciliação',
      glOffsetPendingHelp:
        'Configure a conta contábil da conta bancária ou cartão antes de conciliar. Edite em Configurações > Contas bancárias e cartões.',
      loadError: 'Falha ao carregar itens para conciliação',
      addAdjustmentError: 'Falha ao adicionar ajuste',
      removeAdjustmentError: 'Falha ao remover ajuste',
      confirmError: 'Falha ao confirmar conciliação',
      apSettlementAdjustmentUnassigned:
        'Não foi possível conciliar porque os juros, a multa, o desconto ou o arredondamento não estão ligados a uma conta a pagar. Quando o grupo tiver mais de uma conta a pagar, ou também um recebimento, aplique o ajuste na conta correspondente e tente novamente.',
      apSettlementAdjustmentNotPayable:
        'Não foi possível conciliar porque há um ajuste que não entra na liquidação da conta. Retire a tarifa, o imposto retido ou o adiantamento e tente novamente. Nada foi pago.',
      partialPaymentReconciled:
        'Pagamento parcial de {{amount}} conciliado. Saldo restante: {{remaining}}',
      sourceAlreadyLinked:
        'Uma ou mais transações já estão vinculadas a outro grupo. Edite ou exclua o grupo existente na fila de revisão.',
      glPostingWarningDescription:
        'A conciliação foi concluída, mas houve um problema na postagem contábil.',
    },
    result: {
      successTitle: 'Conciliação confirmada',
      successDescription: 'A transação foi conciliada com sucesso.',
      warningTitle: 'Conciliação confirmada com ressalvas',
      warningDescription:
        'A conciliação foi registrada, porém ocorreram problemas na postagem contábil.',
      errorTitle: 'Falha na conciliação',
      errorDescription: 'Não foi possível conciliar a transação.',
      nextTransaction: 'Próxima transação',
      nextPending: 'Próxima pendente',
      noMorePending: 'Todos os itens pendentes foram revisados.',
      nextPendingError: 'Não foi possível buscar a próxima transação pendente.',
      viewReconciliation: 'Ver conciliação',
      backToList: 'Voltar para a lista',
      glPosting: {
        missingAccountTitle: 'Conta do sistema não configurada',
        missingAccountDescription:
          'Configure o mapeamento GL para {{slotLabel}} ou selecione uma conta abaixo.',
        periodClosedTitle: 'Período contábil fechado',
        periodClosedDescription: 'O período contábil para a data da transação está fechado.',
        periodClosedHint: 'Esta tarefa ficará pendente no checklist de fechamento.',
        unknownTitle: 'Falha na postagem contábil',
        genericWarning: 'Não foi possível concluir a postagem no razão.',
        saveMappingAndPost: 'Salvar mapeamento e postar',
        leavePending: 'Deixar pendente',
        openSettings: 'Abrir configurações',
        accountLabel: 'Conta contábil',
        accountPlaceholder: 'Selecione a conta',
        retrySuccess: 'Postagem contábil concluída.',
        historicalLedgerSkipped: 'Já contabilizado no histórico importado — sem lançamento',
        retryError: 'Não foi possível concluir a postagem. Tente novamente.',
        saving: 'Salvando...',
      },
    },
    bulkCompletion: {
      title: 'Revisão concluída!',
      reconciled: '{{count}} conciliada(s)',
      ignored: '{{count}} ignorada(s)',
      skipped: '{{count}} pulada(s)',
      glWarningsTitle: 'Avisos de postagem contábil',
      close: 'Fechar',
    },
    paymentMismatch: {
      title: 'Pagamento parcial: valor diferente do agendado',
      titleConfirmed: 'Pagamento parcial: pagamento já confirmado',
      descriptionBeforeApproval:
        'Essa conta tem um {{method}} agendado no valor de {{amount}}. O que deseja fazer com o pagamento existente?',
      descriptionBeforeApprovalMany:
        'Essa conta tem {{count}} pagamentos agendados, no total de {{amount}}. O que deseja fazer com os pagamentos existentes?',
      descriptionApproved:
        'Essa conta tem um {{method}} agendado no valor de {{amount}}. Como essa conta já está aprovada, o saldo do pagamento parcial fica como outro pagamento agendado na conta.',
      descriptionApprovedMany:
        'Essa conta tem {{count}} pagamentos agendados, no total de {{amount}}. Como essa conta já está aprovada, o saldo do pagamento parcial fica como outro pagamento agendado na conta.',
      descriptionConfirmed:
        'Essa conta já tem um pagamento confirmado pelo banco com valor divergente. Confira a transação. Caso queira substituir, justifique abaixo.',
      existingTitle: 'Pagamentos da conta',
      existingTitleBill: 'Pagamentos da {{bill}}',
      dueDate: 'vence {{date}}',
      choiceTitle: 'O que fazer com o saldo de {{amount}}?',
      leaveOpen: 'Deixar {{amount}} em aberto na conta',
      leaveOpenDescription:
        'Cancela o pagamento existente. O saldo fica em aberto, sem pagamento agendado.',
      scheduleRemainder: 'Agendar novo {{method}} de {{amount}}',
      scheduleRemainderDescription:
        'Cancela o pagamento existente e agenda o saldo com a mesma forma de pagamento, conta e vencimento.',
      simulationTitle: 'Resultado',
      simulationCancelled: 'Cancelado: {{method}} de {{amount}}',
      simulationPaidNow: 'Pago com esta transação',
      simulationLeftOpen: 'Fica em aberto na conta',
      simulationNewScheduled: 'Novo {{method}} agendado · vence {{date}}',
      heldByBankTitle: 'Esse pagamento já está no banco',
      heldByBankDescription:
        'O Alchemy ERP não cancela pagamentos no banco. Cancele no banco antes de confirmar, para o fornecedor não receber duas vezes.',
      heldByBankConfirm: 'Confirmo que cancelei esse pagamento no banco',
      justificationLabel: 'Justificativa',
      justificationPlaceholder: 'Por que substituir o pagamento confirmado?',
      justificationTooShort: 'Escreva pelo menos {{min}} caracteres.',
      methods: {
        PIX: 'Pix',
        BOLETO: 'boleto',
        TED: 'TED',
        OTHER: 'pagamento',
      },
      confirm: 'Confirmar e conciliar',
      back: 'Voltar',
      noticeTitle: 'Os pagamentos da {{bill}} não batem com esta transação',
      noticeDescription: 'Escolha o que fazer com os pagamentos dessa conta e concilie de novo.',
      noticeAction: 'Ajustar pagamentos da {{bill}}',
      billLabel: 'NF {{number}}',
      billFallback: 'conta',
      paymentStatus: {
        SCHEDULED: 'Agendado',
        PENDING: 'Pendente',
        PROCESSING: 'Em processamento',
        PAID: 'Pago',
        OTHER: 'Em aberto',
      },
      retryFailed: 'Não foi possível concluir a conciliação. Tente de novo.',
      refusals: {
        RECONCILIATION_PAYMENT_MISMATCH:
          'O valor do banco não bate com os pagamentos da conta. Escolha o que fazer com os pagamentos existentes.',
        RECONCILIATION_PAYMENT_MISMATCH_STALE:
          'A conta mudou desde que você abriu esta tela. Feche e abra a conciliação de novo.',
        RECONCILIATION_PAYMENT_MISMATCH_JUSTIFICATION_REQUIRED:
          'Essa conta tem um pagamento confirmado pelo banco. Escreva um motivo com pelo menos 10 caracteres para substituí-lo.',
        RECONCILIATION_PAYMENT_MISMATCH_BANK_CANCELLATION_REQUIRED:
          'Esse pagamento foi enviado ao banco. Cancele no banco e confirme que cancelou.',
        RECONCILIATION_PAYMENT_MISMATCH_REMAINDER_INVALID:
          'Uma conta aprovada precisa agendar o saldo restante como um novo pagamento.',
        RECONCILIATION_PAYMENT_MISMATCH_PAYMENT_POSTED:
          'Esse pagamento já tem lançamentos contábeis e não pode ser substituído aqui. Edite os pagamentos da conta para bater com o valor do banco.',
        RECONCILIATION_PAYMENT_MISMATCH_SEND_IN_FLIGHT:
          'Esse pagamento está sendo enviado ao banco agora. Espere o envio terminar e concilie de novo.',
        RECONCILIATION_PAYMENT_MISMATCH_PERMISSION_REQUIRED:
          'Para substituir um pagamento confirmado ou que está no banco, você precisa da permissão de cancelar pagamentos do Contas a Pagar. Peça a quem tem essa permissão para concluir esta conciliação. Nada foi alterado.',
      },
      permissionRequired:
        'Para substituir um pagamento confirmado ou que está no banco, você precisa da permissão de cancelar pagamentos do Contas a Pagar. Peça a quem tem essa permissão para concluir esta conciliação.',
    },
    suggestions: {
      title: 'Sugestões de Conciliação',
      loading: 'Buscando melhores sugestões...',
      emptyTitle: 'Nenhuma sugestão encontrada',
      emptyDescription:
        'Não encontramos correspondências automáticas para as transações selecionadas.',
      matches: 'Contas a Pagar Sugeridas',
      count: 'encontradas',
      adjustmentsTitle: 'Ajustes Financeiros Sugeridos',
      method: {
        RULES: 'Regras',
        AI: 'IA',
        HYBRID: 'Híbrido',
      },
      toggle: {
        showExplanations: 'Mostrar explicações',
        hideExplanations: 'Ocultar explicações',
      },
      actions: {
        viewDetails: 'Ver detalhes',
        accept: 'Aceitar',
        reject: 'Rejeitar',
        apply: 'Aplicar',
      },
    },
  },
  matching: {
    loading: 'Carregando sugestões...',
    loadError: 'Erro ao carregar sugestões',
    noCandidates: 'Nenhuma sugestão encontrada',
    noCandidatesDescription: 'Não há correspondências automáticas para esta transação.',
    candidatesFound: '{{count}} sugestões encontradas',
    candidatesFound_plural: '{{count}} sugestões encontradas',
    lastUpdated: 'Atualizado em',
    originTransaction: 'Transação',
    scoreBreakdown: 'Detalhes do Score',
    viewScoreDetails: 'Ver detalhes do score',
    noDetailedScore: 'Detalhes do score não disponíveis para esta conciliação.',
    relatedAccount: 'Conta Relacionada',
    select: 'Selecionar',
    selected: 'Selecionado',
    amount: 'Valor',
    date: 'Data',
    vendor: 'Fornecedor',
    vendorAdvancement: 'Adiantamento a fornecedor',
    reimbursementBadge: 'Reembolso',
    customer: 'Cliente',
    account: 'Conta',
    status: 'Status',
    description: 'Descrição',
    counterparty: 'Contraparte',
    storedCandidatesTitle: 'Sugestões de Match',
    storedCandidatesDescription:
      'Possíveis correspondências encontradas automaticamente para esta transação',
    showAllAccounts: 'Ver todas',
    showSuggestions: 'Ver sugestões',
    billTotalAmount: 'Valor total da conta',
    billTotalAccountShort: 'Total da conta',
    paymentAmount: 'Valor pagamento',
    netPayableAmount: 'Valor líquido a pagar',
    grossAmountShort: 'Valor bruto',
    payments: 'Pagamentos',
    selectPayment: 'Selecionar pagamento',
    paymentOrdinal: 'Pagamento {{n}}',
    // Reconciliation preview translations
    reconciliationSummary: 'Resumo da Conciliação',
    totalOrigin: 'Transação',
    totalTarget: 'Conta',
    difference: 'Diferença',
    valuesNotMatching: 'Os valores não conferem',
    differenceNote: 'A diferença será ignorada para esta conciliação',
    howToHandleDifference: 'Como tratar a diferença?',
    // Difference handling options (side-by-side buttons)
    adjust: 'Ajustar',
    newRecord: 'Nova conta',
    ignore: 'Ignorar',
    // Expanded details for each option
    adjustmentDescription: 'Registrar a diferença de',
    asAdjustment: 'como ajuste',
    selectAdjustmentType: 'Selecione o tipo',
    newRecordDescription: 'Criar registro de',
    selectRecordType: 'Selecione o tipo',
    newRecordTypes: {
      bill: 'Conta a Pagar',
      billDesc: 'Criar nova conta a pagar (AP)',
      ar: 'Conta a Receber',
      arDesc: 'Criar nova conta a receber (AR)',
      transfer: 'Transferência',
      transferDesc: 'Registrar como transferência interna',
    },
    ignoreDescription: 'A diferença de',
    willBeIgnored: 'não será registrada',
    selectDifferenceAction: 'Selecione como tratar a diferença',
    addAdjustment: 'Adicionar ajuste',
    adjustmentsTotal: 'Total dos ajustes',
    remainingToAllocate: 'Falta alocar: {{amount}}',
    overAllocated: 'Excedente: {{amount}}',
    // Legacy keys (kept for compatibility)
    newBill: 'Nova conta',
    newBillDescription: 'Criar conta a pagar de',
    billForExtraAmount: 'Valor adicional pago será registrado como nova conta',
    billForPendingAmount: 'Valor pendente será registrado como nova conta a pagar',
    // Legacy keys (kept for compatibility)
    addAsAdjustment: 'Adicionar como ajuste',
    createNewBill: 'Criar nova conta',
    createBillForExtra: 'Criar conta a pagar para o valor adicional',
    createBillForMissing: 'Criar conta a pagar para o valor pendente',
    ignoreDifference: 'Ignorar a diferença',
    differenceWillBeIgnored: 'A diferença não será registrada',
    cancel: 'Cancelar',
    confirming: 'Conciliando...',
    confirmReconciliation: 'Conciliar',
    reconciliationSuccess: 'Conciliação realizada com sucesso!',
    reconciliationError: 'Erro ao conciliar. Tente novamente.',
    candidateType: {
      payment: 'Pagamento',
      bill: 'Conta a Pagar',
      invoice: 'Conta a Receber',
      cardStatement: 'Fatura de Cartão',
      transfer: 'Transferência',
    },
    confidence: 'Confiança',
    selectedBadge: 'SELECIONADO',
    factors: {
      amount: 'Valor',
      exactAmount: 'Valor exato',
      date: 'Data',
      counterparty: 'Fornecedor',
      paymentMethod: 'Método de Pagamento',
      automated: 'Match Automático',
      description: 'Descrição',
      recurringBoost: 'Bill recorrente',
      fastPath: 'Fast Path',
      referenceCode: 'Código de Referência',
      adjustmentExplanation: 'Ajustes',
    },
    dateTypes: {
      dueDate: 'Data de Vencimento',
      issueDate: 'Data de Emissão',
      managerialDate: 'Data Gerencial',
      competencyDate: 'Data de Competência',
      reimbursementDueDate: 'Vencimento do reembolso',
      scheduledDate: 'Data Agendada',
      paidDate: 'Data de Pagamento',
      postedAt: 'Data Postagem',
      effectiveAt: 'Data Efetiva',
      default: 'Data',
    },
  },
  inbox: {
    pageTitle: 'Conciliação bancária',
    acquirerReport: {
      action: 'Relatório do adquirente',
      title: 'Importar relatório do adquirente',
      description:
        'As capturas aprovadas do relatório viram a expectativa de crédito por lote, dia e moeda, no horário de corte do trilho. O motor concilia os créditos do banco contra elas.',
      entity: 'Entidade',
      entityPlaceholder: 'Selecione a entidade',
      rail: 'Trilho (adquirente)',
      railPlaceholder: 'Selecione o trilho',
      noRails: 'Nenhum trilho configurado para esta entidade',
      cutoff: 'corte {{hour}}h UTC',
      files: 'Arquivos CSV do relatório',
      filesHint: 'Um mês costuma vir em vários arquivos; envie todos de uma vez.',
      confirm: 'Importar',
      cancel: 'Cancelar',
      close: 'Fechar',
      imported: '{{recorded}} lote(s) registrado(s), {{skipped}} já existiam.',
      summary:
        '{{files}} arquivo(s), {{rows}} linhas: {{charges}} capturas aprovadas, {{refunds}} reembolsos (não abatem o lote).',
      batches: '{{batches}} lote(s) — {{recorded}} registrado(s), {{skipped}} já existiam.',
    },
    extratosToggle: {
      expand: 'Expandir',
      collapse: 'Recolher',
      ariaExpand: 'Expandir o painel de extratos por conta e cartão',
      ariaCollapse: 'Recolher o painel de extratos',
    },
    extratosPanel: {
      legendReconciled: 'conciliado',
      legendSuggestion: 'sugestão',
      legendPending: 'pendente',
      viewFull: 'Ver extratos completos →',
      empty: 'Nenhuma conta ou cartão com extrato neste período.',
      statementAt: 'extrato @{{date}}',
      noStatementDate: 'sem data de extrato',
      pendingShort: 'pend.',
      pendingVolumeShort: 'pend.',
      pendingVolumeHint:
        'Inclui analisando e sugestões (transações ainda não conciliadas neste período).',
      reconciledShort: 'conc.',
      selectedBadge: 'Selecionado',
      selectedBankScope: 'Conta selecionada: {{name}}',
      selectedCardScope: 'Cartão selecionado: {{name}}',
      selectedTotal: '{{count}} itens',
    },
    title: 'Conciliação Bancária',
    subtitle:
      'Reconcilie transações bancárias, de cartão e de investimento com contas a pagar e a receber',
    viewMode: {
      standard: 'Cards',
      minimal: 'Tabela',
      aria: 'Alternar visualização da lista',
      ariaLabel: 'Visualização',
      cards: 'Cards',
      table: 'Tabela',
      cardsLabel: 'Visualização em cards (foco)',
      tableLabel: 'Visualização em tabela (visão macro)',
    },
    minimalView: {
      childCard: 'Cartão',
      group: {
        bankStatement: 'Extrato Bancário',
        linkedAccount: 'Conta Vinculada',
      },
      columns: {
        date: 'Data',
        description: 'Descrição',
        account: 'Conta',
        value: 'Valor',
        link: 'Vinculação',
        matchValue: 'Valor',
        paymentDate: 'Pagamento',
        dueDate: 'Vencimento',
        confidence: 'Confiança',
        actions: 'Ações',
      },
      matchOrigin: {
        ai: 'IA',
        rules: 'Regras',
        manual: 'Manual',
      },
      confidence: {
        high: 'Alta',
        medium: 'Média',
        low: 'Baixa',
      },
      pending: {
        awaitingAi: 'Aguardando análise da IA',
      },
      accountType: {
        checking: 'Conta corrente',
        savings: 'Poupança',
        investment: 'Investimento',
        card: 'Cartão',
        other: 'Conta',
      },
      accountTooltip: {
        branch: 'Ag',
        account: 'Conta',
        aria: 'Conta: {{account}}',
      },
      rowActionsMenu: 'Ações da transação',
      transactionDetailsAria: 'Detalhes da transação',
      rowDetails: {
        title: 'Detalhes da transação',
        date: 'Data',
        account: 'Conta',
        counterparty: 'Contraparte',
        description: 'Descrição',
        amount: 'Valor',
        type: 'Tipo',
        direction: 'Direção',
        debit: 'Débito',
        credit: 'Crédito',
        paymentMethod: 'Forma de pagamento',
        document: 'Documento',
        reference: 'Referência',
        foreignAmount: 'Valor em moeda estrangeira',
        installment: 'Parcelamento',
        operationType: 'Operação (Open Finance)',
        providerCategory: 'Categoria (Open Finance)',
        providerSubCategory: 'Subcategoria',
        cnae: 'CNAE',
        counterpartyBank: 'Banco da contraparte',
      },
    },
    common: {
      close: 'Fechar',
    },
    details: {
      title: 'Alterar transação',
    },
    reconciliationDetails: {
      title: 'Detalhes da Conciliação',
    },
    glPostingBanner: {
      title: 'Postagem contábil pendente',
      count: '{{count}} vínculo(s) com pendência',
      neverPosted: 'Postagem nunca realizada',
      retry: 'Tentar novamente',
      triggerPosting: 'Disparar postagem',
      linkLabel: '{{targetType}} · {{amount}}',
      refreshError: 'Não foi possível atualizar os dados da conciliação.',
      expandDetails: 'Ver detalhes',
      collapseDetails: 'Ocultar detalhes',
      collapseBanner: 'Recolher alerta',
      expandBanner: 'Expandir alerta',
      collapseBannerAria: 'Recolher o alerta de postagem contábil pendente',
      expandBannerAria: 'Expandir o alerta de postagem contábil pendente',
      relatedBillFailureContext: 'Fatura (vínculo consolidado no pagamento): {{reason}}',
      awaitingBillApprovalBanner:
        'Postagem contábil pendente — será realizada automaticamente quando a conta vinculada for aprovada',
      awaitingBillApprovalRowHint:
        'Será realizada automaticamente quando a conta vinculada for aprovada.',
    },
    review: {
      title: 'Revisar transação',
      titleReconciled: 'Item Conciliado',
      titleAwaitingPair: 'Aguardando perna correspondente',
      awaitingPair: {
        cardTitle: 'Aguardando perna correspondente',
        cardDescription:
          'Esta transferência foi marcada como interna e a perna de Trânsito já foi postada na contabilidade. O par será vinculado automaticamente assim que a transação correspondente aparecer no extrato.',
        cardHint:
          'Enquanto isso, o valor permanece em "Numerários em Trânsito" e a transação não precisa de mais nenhuma ação.',
      },
      reconciled: {
        valuesColumn: 'Valor',
        financialAdjustments: 'Ajustes financeiros',
        datesColumn: 'Datas',
        glPostingFailedTitle: 'Falha na postagem contábil',
        glPostingFailedFallback: 'Erro desconhecido durante a postagem.',
        billFaceLabel: 'Valor na moeda da fatura',
        cardChargeLabel: 'Cobrança no cartão ({{currency}})',
        extraAdjustmentsBrl:
          'Ajustes adicionais em {{currency}} (não substituem o valor em moeda estrangeira da fatura)',
        cardTotalEquals: 'O valor total lançado no cartão é a cobrança em {{currency}} acima',
      },
    },
    ignoredNoSuggestions:
      'Transação ignorada. Clique em Desfazer ignorado para voltar a analisar e ver as opções de conciliação.',
    focusMode: {
      title: 'Modo foco',
      itemCount: '{{current}} de {{total}}',
      shortcutAddInterestAndReconcile: 'Juros e conciliar',
      shortcutAddFeeAndReconcile: 'Tarifa e conciliar',
      shortcutAddDiscountAndReconcile: 'Desconto e conciliar',
      discountConfirmTitle: 'Confirmar desconto e conciliar',
      discountConfirmDescription:
        'Esse pagamento será conciliado com a nota e será aplicado um desconto de {{amount}}, que ficará visível na conta a pagar e será postado no livro razão.',
      discountConfirmAction: 'Aplicar desconto e conciliar',
      shortcutReconcile: 'Conciliar',
      shortcutInternalOp: 'Conciliar como operação interna',
      shortcutIgnoreAndNext: 'Ignorar e próximo',
      shortcutTransfer: 'Conciliar transferência',
      noPendingItems: 'Nenhum item pendente para conciliar',
      shortcutsAria: 'Atalhos de conciliação',
    },
    aria: {
      selectAll: 'Selecionar todos',
      selectItem: 'Selecionar {{description}}',
      openMenu: 'Abrir menu',
      actions: 'Ações',
    },
    tabs: {
      pending: 'Analisando',
      suggestions: 'Sugestões',
      matched: 'Em match',
      reconciled: 'Conciliados',
      ignored: 'Ignorados',
      all: 'Todos',
    },
    summary: {
      pending: 'Analisando',
      suggestions: 'Sugestões',
      matched: 'Em match',
      reconciled: 'Conciliados',
      ignored: 'Ignorados',
      todos: 'Todos',
    },
    filters: {
      title: 'Filtros',
      active: 'Filtros ativos:',
      account: 'Conta',
      accountPlaceholder: 'Selecionar conta',
      entity: 'Entidade',
      entityAll: 'Todas as entidades',
      entityLoading: 'Carregando entidades',
      entityCount_one: '{{count}} entidade',
      entityCount_other: '{{count}} entidades',
      entityError: 'Não foi possível carregar as entidades',
      description: 'Descrição',
      search: 'Busca geral',
      document: 'Documento',
      documentPlaceholder: 'CPF, CNPJ ou identificação fiscal',
      status: 'Status',
      statusPlaceholder: 'Todos',
      amount: 'Valor',
      amountPlaceholder: 'Valor',
      amountOp: {
        eq: 'Igual',
        gte: 'Maior ou igual',
        lte: 'Menor ou igual',
      },
      transactionType: 'Tipo de transação',
      transactionTypePlaceholder: 'Selecionar tipo',
      transactionTypeAll: 'Todos',
      transactionTypeDebit: 'Contas a pagar',
      transactionTypeCredit: 'Contas a receber',
      transactionTypeTransfer: 'Transferência entre contas',
      transactionTypeYield: 'Rendimentos',
      transactionTypeInternalOp: 'Operações internas',
      transactionTypeFeeTax: 'Tarifas e taxas',
      transactionTypeEmployeePayment: 'Folha de pagamento',
      transactionTypeOther: 'Outros',
      transferSubType: 'Tipo de transferência',
      transferSubTypePlaceholder: 'Selecionar tipo',
      transferSubTypes: {
        all: 'Todas',
        internal: 'Entre contas próprias',
        investment: 'Investimentos',
        pending: 'Aguardando match',
      },
      paymentMethod: 'Método',
      paymentMethodPlaceholder: 'Selecionar método',
      paymentMethodAll: 'Todos',
      confidence: 'Confiança',
      confidenceMin: 'Mín %',
      confidenceMax: 'Máx %',
      dateRange: 'Período',
      datePlaceholder: 'Período',
      adjustment: 'Ajuste',
      adjustmentAll: 'Todos',
      adjustmentWith: 'Com ajuste',
      adjustmentWithout: 'Sem ajuste',
      adjustmentPlaceholder: 'Com ou sem ajuste',
      clear: 'Limpar filtros',
      clearAll: 'Limpar todos',
      apply: 'Aplicar',
      sourceMaskActive: 'Tipos personalizados',
    },
    sourceToggles: {
      aria: 'Tipo de origem',
      showLabel: 'Mostrar: ',
      bankAccount: 'Conta Bancária',
      creditCard: 'Cartão de Crédito',
      checkingAccount: 'Conta corrente',
      cardShort: 'Cartão',
      investment: 'Investimento',
      filterLabel: 'Origem',
      lockedByAccount: 'Limpe a conta selecionada para filtrar por tipo.',
    },
    row: {
      empty: '—',
      credit: 'Crédito',
      debit: 'Débito',
    },
    paymentMethods: {
      creditCard: 'Cartão de crédito',
      pix: 'Pix',
      ted: 'TED',
      doc: 'DOC',
      boleto: 'Boleto',
      card: 'Cartão',
      directDebit: 'Débito automático',
      directCredit: 'Crédito automático',
      spei: 'SPEI',
      transfer: 'Transferência',
      fee: 'Tarifa',
      tax: 'Imposto',
      unknown: 'Desconhecido',
    },
    status: {
      pending: 'Analisando',
      matched: 'Match encontrado',
      lowConfidenceSuggestion: 'Sugestão pouco confiável',
      reconciled: 'Conciliado',
      reconciledAuto: 'Conciliado (Auto)',
      reconciledRules: 'Conciliado (Regras)',
      reconciledHistorical: 'Conciliado (Histórico)',
      reconciledAI: 'Conciliado (IA)',
      reconciledManual: 'Conciliado (Manual)',
      ignored: 'Ignorado',
      needsReview: 'Requer Revisão',
    },
    internalOperation: {
      yield: 'Rendimento',
      rescue: 'Resgate',
      application: 'Aplicação',
      other: 'Op. Interna',
      badge: 'Op. Interna',
    },
    badges: {
      transfer: 'Transferência',
      internalTransfer: 'Transf. Interna',
      investmentTransfer: 'Transf. Investimento',
      fee: 'Tarifa',
      cardStatement: 'Fatura de cartão',
    },
    transferInfo: {
      fromAccount: 'De',
      toAccount: 'Para',
      linkedAccount: 'Conta vinculada',
    },
    linkedAccount: {
      adjustment: 'Ajuste',
      vendorAdvanceBalance: 'Saldo de adiantamento a fornecedor',
      bankTransaction: 'TRANSAÇÃO BANCÁRIA',
      linkedAccount: 'CONTA VINCULADA',
      suggestedByAi: 'SUGERIDO PELA IA',
      noMatch: 'Sem correspondência',
      awaitingAnalysis: 'Aguardando análise da IA ou vínculo manual',
      awaitingPairBadge: 'Aguardando par',
      awaitingPairTitle: 'Aguardando perna correspondente',
      awaitingPairHint:
        'Transferência interna postada em "Numerários em Trânsito"; o par será vinculado quando a outra transação aparecer no extrato.',
      link: 'Vincular',
      linkTooltip: 'Vincular manualmente',
      confirm: 'Confirmar',
      reject: 'Rejeitar',
      viewOtherBills: 'Ver outras contas',
      alternateRejectDisabled: 'Rejeitar aplica-se à sugestão principal',
      reconcileWith: 'Conciliar com esta conta',
      alternateTypeBill: 'Conta a pagar',
      alternateTypePayment: 'Pagamento',
      payment: 'Pagamento',
      transaction: 'Transação',
      details: {
        billNumber: 'Nº fatura',
        dueDate: 'Venc.',
        issueDate: 'Emissão',
        managerialDate: 'Competência',
        billStatus: 'Status',
        paymentNumber: 'Parcela',
        paymentStatus: 'Status',
        invoiceNumber: 'Nº NF',
        invoiceStatus: 'Status',
        toAccount: 'Para',
        transferTo: 'Para {{account}}',
        bank: 'Banco',
        branch: 'Ag',
        accountNumber: 'Conta',
      },
    },
    confidence: {
      high: 'Alta',
      medium: 'Média',
      low: 'Baixa',
      auto: 'Automático',
      manual: 'Manual',
    },
    card: {
      search: 'Buscar',
      undo: 'Desfazer',
      parcela: 'parcela',
      ajuste: 'ajuste',
      juros: 'juros',
    },
    cancelPosted: {
      title: 'Cancelar reconciliação',
      description:
        'Os lançamentos contábeis serão estornados no período selecionado e a conciliação será cancelada.',
      simpleDescription:
        'A conciliação será cancelada e os vínculos operacionais serão revertidos.',
      confirm: 'Confirmar estorno e cancelamento',
      postingsToReverse: 'Lançamentos que serão estornados',
      reconciledPaymentsWarning:
        'Esta conciliação também afeta pagamentos já reconciliados. O cancelamento irá reverter esses vínculos operacionais junto com o estorno contábil.',
      sharedImpactTitle: 'Esta conciliação também afeta {{count}} outro(s) item(ns)',
      sharedImpactDescription:
        'Desfazer a conciliação reverte todos os itens abaixo, não apenas o pagamento que você abriu.',
      sharedImpactPayment: 'Pagamento de outra conta',
      sharedImpactSameBillPayment: 'Outro pagamento desta conta',
      sharedImpactBill: 'Conta a pagar',
      sharedImpactInvoice: 'Fatura a receber',
      refreshFailed:
        'Conciliação desfeita, mas não foi possível atualizar a tela. Recarregue a página para ver o saldo atualizado.',
    },
    actions: {
      reconcile: 'Conciliar',
      ignore: 'Ignorar',
      unignore: 'Desfazer ignorado',
      viewDetails: 'Alterar transação',
      viewReconciliation: 'Ver detalhes',
      viewReconciliationDetails: 'Detalhes da Conciliação',
      viewBill: 'Ver conta a pagar',
      viewInvoice: 'Ver conta a receber',
      refresh: 'Atualizar',
      sync: 'Sincronizar',
      import: 'Importar',
      importOfx: 'Importar OFX',
      importCard: 'Importar Fatura',
      processingPending: 'Pendências',
      bulkReconcile: 'Conciliar selecionados',
      bulkIgnore: 'Ignorar',
      bulkEdit: 'Alterar dados',
      focusMode: 'Modo foco',
      retryPending: 'Reprocessar',
      bulkCancel: 'Cancelar',
      clearSelection: 'Limpar seleção',
    },
    bulkEdit: {
      title: 'Alterar dados das transações',
      description:
        'Altere o tipo de transação e/ou método de pagamento. Apenas transações bancárias serão atualizadas; itens de cartão serão ignorados.',
      transactionType: 'Tipo de transação',
      transactionTypePlaceholder: 'Não alterar',
      paymentMethod: 'Método de pagamento',
      paymentMethodPlaceholder: 'Não alterar',
      apply: 'Aplicar',
      noChanges: 'Selecione pelo menos um campo para alterar.',
    },
    groups: {
      noImport: 'Sem importação',
      import: 'Importação',
      importedAt: 'Importado em {{date}}',
      count: '{{count}} item',
      count_plural: '{{count}} itens',
      loadMore: 'Carregar mais',
    },
    table: {
      date: 'Data',
      description: 'Descrição',
      counterparty: 'Contraparte',
      amount: 'Valor',
      paymentMethod: 'Método',
      account: 'Conta',
      reconciledWith: 'Conciliado com',
      reconciledWithVenc: 'venc.',
      reconciledWithGlFailed: 'GL falhou',
      status: 'Status',
      statusAndAi: 'Status / IA',
      confidence: 'Confiança',
      actions: 'Ações',
    },
    searchPlaceholder: 'Descrição, contraparte, referência, boleto, categoria...',
    bulkCount: '{{count}} item selecionado',
    bulkCount_plural: '{{count}} itens selecionados',
    loading: 'Carregando...',
    empty: 'Nenhum item encontrado.',
    dateStart: 'Data inicial',
    dateEnd: 'Data final',
    pagination: 'Página {{page}} de {{total}}',
    showingItems: 'Mostrando {{from}} a {{to}} de {{total}} itens',
    itemsPerPage: 'Itens por página:',
    prevPage: 'Anterior',
    nextPage: 'Próximo',
    balance: {
      currentLabel: 'Saldo atual:',
      updatedAt: 'em {{date}} às {{time}}',
    },
    counterparty: {
      search: 'Buscar contraparte',
      searchPlaceholder: 'Buscar por nome ou documento...',
      searching: 'Buscando...',
      notFound: 'Nenhum fornecedor encontrado',
      notFoundVendor: 'Nenhum fornecedor encontrado',
      notFoundCustomer: 'Nenhum cliente encontrado',
      notFoundBank: 'Nenhuma conta encontrada',
      typeToSearch: 'Digite para buscar',
      createNew: 'Criar novo fornecedor',
      createVendor: 'Criar novo fornecedor',
      createCustomer: 'Criar novo cliente',
      createBankAccount: 'Cadastrar conta bancária',
    },
    messages: {
      loadError: 'Falha ao carregar itens de conciliação',
      refreshed: 'Itens atualizados com sucesso',
      uploadSuccess: 'Arquivo enviado com sucesso',
      uploadError: 'Falha ao enviar arquivo',
      confirmIgnore: 'Deseja ignorar esta transação?',
      confirmIgnoreExplanation:
        'A transação será marcada como ignorada: sai das filas pendentes e de sugestões automáticas. Você pode encontrá-la na aba Ignorados ou reativá-la com Desfazer ignorado, quando disponível.',
      confirmBulkIgnoreExplanation:
        '{{count}} transação(ões) selecionada(s) serão marcadas como ignoradas: saem das filas pendentes e de sugestões. Você pode encontrá-las na aba Ignorados ou reativá-las depois.',
      confirmIgnoreFocusExplanation:
        'A transação será marcada como ignorada e você avançará para o próximo item. Ela sai das filas pendentes; encontre-a na aba Ignorados ou use Desfazer ignorado para reativar.',
      confirmUndo: 'Tem certeza que deseja desfazer a conciliação desta transação?',
      confirmUndoTitle: 'Desfazer conciliação?',
      confirmUndoExplanation: 'Esta ação desfaz a conciliação e retorna o item para análise.',
      ignored: 'Transação ignorada',
      ignoreError: 'Falha ao ignorar',
      ignoreErrorCreatedTransferLeg:
        'Este movimento foi criado pela conciliação de uma transferência e não pode ser ignorado. Para removê-lo, desfaça a conciliação pelo movimento de origem.',
      ignoreErrorLiveGlPosting:
        'Esta conciliação tem lançamentos contábeis ativos. Desfaça a conciliação, informando data e justificativa do estorno, antes de ignorar o movimento.',
      unignored: 'Transação retornou ao status de análise',
      unignoreError: 'Falha ao desfazer ignorado',
      undoSuccess: 'Conciliação desfeita com sucesso',
      undoError: 'Falha ao desfazer conciliação',
      undoErrorJustificationRequired:
        'Informe uma justificativa para estornar os lançamentos contábeis desta conciliação.',
      undoErrorLiveGlPosting:
        'Esta conciliação tem lançamentos contábeis ativos. Para desfazer, estorne os lançamentos informando data e justificativa; a conta continuará aprovada se apenas o pagamento for desfeito.',
      undoErrorMovementJournalPosted:
        'Este rendimento ou imposto (IR/IOF) já foi contabilizado no próprio movimento bancário, e o desfazer não estorna esse lançamento. Estorne primeiro o lançamento do rendimento/imposto no Razão e depois desfaça a conciliação. Nada foi desfeito.',
      undoErrorCreatedBillNotDraft:
        'A conta criada nesta conciliação não é mais um rascunho (em aprovação, aprovada, contabilizada ou paga). Resolva-a em Contas a Pagar antes de desfazer.',
      undoErrorExportEvidenceSourcePeriodClosed:
        'O período contábil da origem da receita está fechado. Reabra esse período antes de desfazer a conciliação. A prova de exportação e a apuração permanecem protegidas; nada foi desfeito.',
      undoErrorMismatchRemainderInUse:
        'O saldo restante que esta conciliação agendou já foi enviado ao banco ou pago. Desfazer apagaria esse pagamento. Nada foi desfeito. Se outro movimento conciliou esse saldo, desfaça aquela conciliação primeiro. Se o saldo está no banco, mantenha esta conciliação.',
      undoErrorMismatchPaymentNotRestorable:
        'Esta conciliação substituiu um pagamento confirmado ou que estava no banco, ou a conta recebeu outro pagamento depois. Desfazer não consegue voltar a conta ao que era. Nada foi desfeito. Se você adicionou um pagamento depois, exclua-o e tente de novo. Se não, mantenha esta conciliação.',
      undoErrorProviderRemovedPeriodClosed:
        'Reabra o período contábil de {{month}} de {{year}} para desfazer. O lançamento desta linha removida pelo banco está nesse período fechado. Nada foi desfeito.',
      undoDisabledClosedPeriod: 'A conciliação não pode ser editada em períodos fechados',
      bulkIgnoreSuccess: '{{count}} transação(ões) ignorada(s)',
      bulkIgnorePartial: '{{success}} sucesso, {{failed}} falha(s)',
      bulkIgnoreError: 'Falha ao ignorar transações',
      retryPendingSuccess: '{{count}} itens enfileirados para reprocessamento',
      retryPendingNone: 'Nenhum item pendente encontrado para reprocessar',
      retryPendingError: 'Falha ao reprocessar pendentes',
      bulkUpdateSuccess: '{{count}} transação(ões) atualizada(s)',
      bulkUpdatePartial: '{{success}} atualizada(s), {{failed}} não foram transações bancárias',
      bulkUpdateError: 'Falha ao atualizar transações',
      bulkReviewNoResolvedTypes:
        'Não foi possível determinar o tipo das transações selecionadas. Atualize a lista ou selecione novamente.',
      actionNotImplemented: {
        ignore: 'Funcionalidade "ignorar" será implementada',
        viewDetails: 'Funcionalidade "ver detalhes" será implementada',
      },
      openWorkbenchToReconcile:
        'Este tipo de sugestão requer a tela de conciliação. Clique no card para abrir.',
      reconcileError: 'Falha ao conciliar',
      rejectSuggestionSuccess: 'Sugestão rejeitada',
      rejectSuggestionError: 'Falha ao rejeitar sugestão',
      rejectSuggestionNoCandidate: 'Nenhuma sugestão encontrada para rejeitar.',
      rejectSuggestionCardOnly: 'Rejeitar sugestão de cartão requer a tela de conciliação.',
    },
    upload: {
      title: 'Importar Arquivo',
      ofxTitle: 'Importar OFX',
      cardTitle: 'Importar Fatura',
      documentTypeLabel: 'Tipo de Documento',
      documentTypeBank: 'Extrato Bancário',
      documentTypeCard: 'Fatura de Cartão',
      documentTypeBankDesc: 'OFX, CSV, CNAB.RET, CNAB.TXT',
      documentTypeCardDesc: 'CSV, PDF',
      documentTypeHint: 'Formatos suportados: {{formats}}',
      dropzoneTitle: 'Arraste arquivos aqui ou clique para selecionar',
      dropzoneSubtitle: 'Formatos suportados: {{formats}}',
      selectFiles: 'Selecionar Arquivos',
      uploading: 'Enviando...',
      sendFiles: 'Enviar {{count}} arquivo(s)',
      clear: 'Limpar',
      maxFilesError: 'Você só pode selecionar até {{max}} arquivos por vez.',
      filesRemoved:
        'Alguns arquivos foram removidos pois não são compatíveis com o tipo selecionado',
      uploadFilesError: 'Falha ao enviar {{count}} arquivo(s): {{errors}}',
      duplicateFilesError: 'Documento duplicado: {{files}}',
      duplicateFilesWarning: '{{count}} documento(s) duplicado(s): {{files}}',
      duplicateFilesUnknown: 'arquivo(s)',
    },
  },
  statement: {
    title: 'Extrato do período',
    bankStatementHeader: 'Extrato Bancário',
    lancamentos: 'Lançamentos',
    period: 'Período',
    viewStatement: 'Ver extrato',
    viewEnriched: 'Ver extrato',
    viewEnrichedTooltip: 'Ver extrato do período importado',
    description: 'Transações com metadados de conciliação',
    openingBalance: 'Saldo inicial',
    closingBalance: 'Saldo final',
    balanceContinuityWarningTitle: 'Atenção: divergência de saldo',
    snapshotVsDailyTitle: 'Leitura externa vs saldo diário',
    snapshotVsDailySummary: '{{count}} dia com diferença entre snapshot e saldo diário armazenado.',
    snapshotVsDailySummary_plural:
      '{{count}} dias com diferença entre snapshot e saldo diário armazenado.',
    transactionCount: '{{count}} transações',
    loading: 'Carregando extrato...',
    empty: 'Nenhuma transação no período',
    noPeriod: 'Período não informado',
    timeout: 'Tempo esgotado. Tente novamente.',
    error: 'Erro ao carregar extrato',
    exportCsv: 'Exportar CSV',
    balanceAfter: 'Saldo após',
    reconciledCounterparty: 'Contraparte',
    linkedDocument: 'Documento',
  },
  periodHeader: {
    complete: 'Conciliado',
    statement: 'Extrato',
    reconciled: 'Conciliado',
    pendingCount: 'Analisando',
    matchedCount: 'Sugestões',
    reconciledCount: 'Conciliados',
    ignoredCount: 'Ignorados',
    totalCount: 'Todos',
    difference: 'Diferença',
    statements: 'Extratos',
    statementsComplete: 'Extratos completos',
    statementsPending: 'Extratos pendentes',
    statementsPendingCount: '{{count}} pendentes',
    accounts: 'Contas',
    cards: 'Cartões',
    import: 'Importar',
    synced: 'Sincronizado',
    noControl: 'Sem controle',
    legendComplete: 'Extratos completos',
    legendPending: 'Extratos pendentes',
    legendNone: 'Sem controle',
  },
  cardItem: {
    details: 'Detalhes do Item',
    cardStatement: 'Fatura de Cartão',
    itemInfo: 'Informações do Item',
    merchant: 'Estabelecimento',
    amount: 'Valor',
    date: 'Data',
    installment: 'Parcela',
    status: 'Status',
    description: 'Descrição',
    matchCandidates: 'Sugestões de Match',
    noCandidates: 'Nenhuma sugestão encontrada',
    ignore: 'Ignorar',
    confirmIgnoreDescription:
      'Este lançamento da fatura será marcado como ignorado: deixa de aparecer nas sugestões de conciliação. Você pode localizá-lo na aba Ignorados ou reativá-lo com Desfazer ignorado, quando disponível.',
    confirmSuccess: 'Item conciliado com sucesso',
    confirmError: 'Erro ao conciliar item',
    ignoreSuccess: 'Item ignorado',
    ignoreError: 'Erro ao ignorar item',
    createBill: 'Criar Conta a Pagar',
    createBillSuccess: 'Conta criada e conciliada com sucesso',
    createBillError: 'Erro ao criar conta',
  },
  smartUpload: {
    title: 'Upload Inteligente',
    dropzoneTitle: 'Upload Inteligente',
    dropzoneSubtitle:
      'Arraste arquivos de extrato ou fatura. A IA identificará automaticamente o tipo e a conta.',
    selectFiles: 'Selecionar Arquivos',
    clear: 'Limpar',
    analyzeFiles: 'Analisar Arquivos',
    analyzing: 'Analisando arquivos...',
    analyzingDesc: 'A IA está identificando o tipo de documento e extraindo informações.',
    back: 'Voltar',
    import: 'Importar Arquivos',
    importing: 'Importando arquivos...',
    importingDesc: 'Processando e salvando transações.',
    saveProfiles: 'Salvar preferências para importações futuras',
    confidence: 'Confiança',
    detected: 'Detectado',
    suggestedAccount: 'Conta sugerida',
    changeAccount: 'Alterar conta',
    existingProfile: 'Perfil de importação existente encontrado',
    existingProfileShort: 'Perfil salvo',
    bankStatement: 'Extrato Bancário',
    bankStatementShort: 'Extrato',
    cardStatement: 'Fatura de Cartão',
    cardStatementShort: 'Fatura',
    documentTypeLabel: 'Tipo do documento',
    documentTypeHint:
      'Corrija se a IA classificou errado: extrato de conta ou fatura/listagem de cartão.',
    noCardNumberInFile:
      'Nenhum número de cartão (final) foi detectado no arquivo. Selecione o cartão manualmente.',
    transactions: 'transações',
    transactionsShort: 'trans.',
    selectBankAccount: 'Selecione a conta',
    expandCards: 'Expandir',
    collapseCards: 'Resumir',
    removeFile: 'Remover arquivo',
    kaminoIntegrationLink: 'Abrir integração Kamino',
    openFinanceIntegrationLink: 'Abrir Open Finance (integrações)',
    statusReady: 'Pronto',
    statusPending: 'Pendente',
    statusActionRequired: 'Ação necessária',
    statusError: 'Erro',
    accountNotFound: 'Conta não encontrada',
    uncertaintyMessage:
      'Não foi possível identificar a conta com certeza. Selecione uma conta existente ou crie uma nova para vincular.',
    accountNotFoundDetails:
      '{{bankName}} • Banco: {{bankCode}} • Ag: {{branch}} • Conta: {{account}}',
    didYouMean: 'Você quis dizer?',
    selectExistingAccount: 'Ou selecione outra conta:',
    selectAccountOrCreate: 'Selecione uma conta ou crie uma nova:',
    useThis: 'Usar esta',
    changeAccountShort: 'Alterar',
    accountDisplayBank: 'Banco',
    accountDisplayChecking: 'Corrente',
    accountDisplaySavings: 'Poupança',
    accountDisplaySalary: 'Salário',
    accountDisplayPayment: 'Pagamento',
    accountDisplayInvestment: 'Investimento',
    accountDisplayBenefits: 'Benefício',
    filesReadySummary: '{{ready}} de {{total}} arquivos prontos para importar',
    transactionsCount: '{{count}} transações',
    warnings: {
      encoding: 'Encoding detectado como {{encoding}}',
      dateFormat: 'Formato de data incomum detectado',
    },
    errors: {
      analysisNotFound: 'Análise não encontrada',
      unknownError: 'Erro desconhecido',
    },
    bankStatementPdfNotSupported:
      'Extratos bancários em PDF não são suportados. Use formatos OFX ou CSV para importar seu extrato.',
    cardSelectionRequired:
      'Selecione pelo menos um cartão para cada arquivo de fatura antes de importar.',
    quickAdd: {
      bankTitle: 'Cadastro Rápido - Conta Bancária',
      cardTitle: 'Cadastro Rápido - Cartão',
      addBank: 'Cadastrar nova conta',
      addBankShort: 'Nova conta',
      createNewBankAccount: 'Criar nova conta bancária',
      addCard: 'Cadastrar novo cartão',
      addCardShort: 'Novo cartão',
      createBank: 'Criar Conta',
      createCard: 'Criar Cartão',
      cancel: 'Cancelar',
      entity: 'Entidade',
      accountName: 'Nome da Conta',
      accountType: 'Tipo de Conta',
      accountTypeChecking: 'Corrente',
      accountTypeSavings: 'Poupança',
      accountTypeSalary: 'Salário',
      accountTypePayment: 'Pagamento',
      accountTypeInvestment: 'Investimento',
      accountTypeBenefits: 'Benefício',
      bankCode: 'Código do Banco',
      bankName: 'Nome do Banco',
      bankSearch: 'Buscar por nome ou código...',
      detectedBankNameHint: 'Detectado no arquivo: {{bankName}}. Selecione o banco acima.',
      providerName: 'Nome do Provedor',
      platformName: 'Nome da Plataforma',
      branchCode: 'Agência',
      accountNumber: 'Número da Conta',
      cardName: 'Nome do Cartão',
      brand: 'Bandeira',
      lastFourDigits: 'Últimos 4 dígitos',
      cardholderName: 'Titular',
      closingDay: 'Dia Fechamento',
      dueDay: 'Dia Vencimento',
      successBank: 'Conta criada com sucesso!',
      successCard: 'Cartão criado com sucesso!',
      errorBank: 'Erro ao criar conta bancária',
      errorCard: 'Erro ao criar cartão',
      requiredFields: 'Preencha todos os campos obrigatórios',
      duplicateBankAccount:
        'Conta bancária com mesmo banco, agência e número já existe ({{name}}). Selecione-a na lista.',
    },
  },
  bankAccount: {
    notFound: 'Conta bancária não encontrada',
    loadError: 'Erro ao carregar conta bancária',
    importPending: 'Importação recebida. Aguardando processamento...',
    importProcessing: 'Importação em andamento...',
    importCompleted: 'Importação concluída. As movimentações foram atualizadas.',
    importCancelled: 'A importação foi cancelada.',
    importFailed: 'A última importação falhou.',
    importStuck: 'A importação está demorando mais que o esperado.',
    tryAgain: 'Tentar novamente',
    reprocessSuccess: 'Importação reenfileirada. O processamento será retomado em breve.',
    reprocessNoDocuments: 'Nenhum documento encontrado para reprocessar.',
    reprocessError: 'Erro ao tentar novamente. Tente mais tarde.',
    reprocessCompleted: 'Importar transações faltantes',
    reprocessCompletedHint:
      'A reimportação do mesmo arquivo não adiciona transações novas por padrão. Use o botão abaixo para reprocessar extratos já importados e adicionar transações faltantes.',
    reprocessCompletedSuccess:
      'Extratos reenfileirados. As transações faltantes serão importadas em breve.',
    reprocessCompletedNoDocuments: 'Nenhum extrato completado encontrado para reprocessar.',
    meta: {
      currentBalance: 'Saldo atual',
      currentBalanceTooltip: 'Atualizado em {{date}}',
      currentBalanceUnknownDate: 'data desconhecida',
      bank: 'Banco',
      branch: 'Agência',
      account: 'Conta',
      type: 'Tipo',
      entity: 'Entidade',
      copyBranch: 'Copiar agência',
      copyBranchSuccess: 'Agência copiada',
      copyAccount: 'Copiar número da conta',
      copyAccountSuccess: 'Número da conta copiado',
      copyError: 'Erro ao copiar',
    },
    openFinance: {
      unlink: 'Desvincular',
      unlinkComingSoon: 'Desvincular — Em breve',
      unlinkComingSoonTooltip: 'A desvinculação do Open Finance estará disponível em breve.',
      unlinkSuccess: 'Conta desvinculada com sucesso.',
      unlinkError: 'Erro ao desvincular conta. Tente novamente.',
      unlinkDialogTitle: 'Confirmar desvinculação',
      unlinkDialogDescription:
        'A conexão Open Finance será desativada. Esta conta não receberá mais sincronização automática. Deseja continuar?',
      unlinkDialogChecking: 'Verificando se esta conexão é usada por outras contas ou cartões...',
      unlinkDialogCheckError:
        'Não foi possível verificar se esta conexão é compartilhada. Feche e tente novamente.',
      unlinkDialogDescriptionShared:
        'Esta conexão Open Finance também é usada por {{parts}}. Ela será desativada para todos e nenhum deles receberá mais sincronização automática.',
      unlinkDialogSharedAccountsPart_one: '{{count}} outra conta bancária',
      unlinkDialogSharedAccountsPart_other: '{{count}} outras contas bancárias',
      unlinkDialogSharedCardsPart_one: '{{count}} cartão de crédito',
      unlinkDialogSharedCardsPart_other: '{{count}} cartões de crédito',
      unlinkDialogSharedJoiner: ' e ',
      unlinkDialogAcknowledge: 'Entendo que isso também desconecta as contas/cartões acima.',
    },
    tabs: {
      overview: 'Visão Geral',
      statement: 'Extrato',
      internalOps: 'Operações Internas',
      transfers: 'Transferências',
    },
    statement: {
      empty: 'Nenhuma movimentação no período',
      loadError: 'Erro ao carregar extrato',
      balancesOnlyBanner:
        'Você tem acesso apenas aos saldos desta conta. O extrato mostra o saldo agregado por dia, sem as movimentações individuais.',
      balancesOnlyEmpty: 'Nenhum saldo diário no período',
      periodClearedEmptyTitle: 'Nenhum período selecionado',
      periodClearedEmptyDescription: 'Selecione um período para ver o extrato desta conta.',
      periodClearedEmptyAction: 'Selecionar período',
      loadingBalances: 'Carregando saldos...',
      loadingTransactions: 'Carregando extrato...',
      warningsReasonPending_one:
        '{{count}} lançamento pendente, ainda fora do saldo e da conciliação',
      warningsReasonPending_other:
        '{{count}} lançamentos pendentes, ainda fora do saldo e da conciliação',
      warningsReasonBalanceMismatch: 'saldo desatualizado',
      warningsReasonPendingUnverified: 'não foi possível confirmar se há pendências recentes',
      warningsReasonsJoiner: 'e',
      warningsSyncHint: 'Sincronize pelo menu (⋮) para atualizar.',
      warningsFileOnlyHint: 'Confira o saldo informado no arquivo importado.',
      clearFilters: 'Limpar filtros',
      amountLabel: 'Valor da movimentação',
      minAmount: 'Mín',
      maxAmount: 'Máx',
      itemCount: '{{count}} lançamentos',
      itemCountLoaded: '{{loaded}} de {{total}} lançamentos',
      loadingMore: 'Carregando mais lançamentos...',
      loadMore: 'Carregar mais',
      allLoaded: 'Todos os lançamentos do período foram carregados',
      periodCustom: 'Personalizado',
      periodThisMonth: 'Mês atual',
      sectionTitle: 'Extrato',
      expandAll: 'Expandir tudo',
      collapseAll: 'Minimizar tudo',
      expandDateGroup: 'Expandir lançamentos de {{date}}',
      collapseDateGroup: 'Minimizar lançamentos de {{date}}',
      filtersButtonLabel: 'Filtros',
      activeFiltersLabel: 'Filtros ativos:',
      filterChipSearch: 'Busca',
      filterChipType: 'Tipo',
      filterChipPeriod: 'Período',
      filterChipMinAmount: 'Valor mín.',
      filterChipMaxAmount: 'Valor máx.',
      typeFilterLabel: 'Tipo de movimentação',
      periodFilterLabel: 'Período',
      periodFrom: 'De',
      periodTo: 'Até',
      filters: {
        all: 'Todos',
      },
      table: {
        date: 'Data',
        balance: 'Saldo ao final do dia',
        transactionCount: 'Transações',
        time: 'Horário',
        description: 'Descrição',
        type: 'Tipo',
        amount: 'Valor',
        balanceAfter: 'Saldo após',
      },
      noTransactionsForDay: 'Sem movimentação neste dia',
      transactionTypeLabels: {
        INTERNAL_TRANSFER: 'Transferência',
        INTERNAL_OP: 'Interna',
        FEE_TAX: 'Tarifa',
        VENDOR_PAYMENT: 'Pagamento',
        CUSTOMER_RECEIPT: 'Recebimento',
        EMPLOYEE_PAYMENT: 'Folha',
        OTHER: 'Outros',
      },
      summaryCards: {
        balance: 'Saldo',
        connection: 'Conexão bancária',
        connectedOpenFinance: 'Conectado via Open Finance',
        connectedKamino: 'Conectado via Kamino',
        connectedPlaid: 'Conectado via Plaid',
        notConnected: 'Não conectado',
        connectionTooltip:
          'Sincroniza automaticamente (quase em tempo real, com reforços periódicos). Saldo e extrato podem levar um instante para convergir.',
        pending: 'Pendências',
        pendingTooltip:
          'Conta apenas o período e o tipo de movimentação selecionados no extrato abaixo — não é o total de pendências da conta.',
      },
      manageConnectionHint: 'Gerenciado em',
      manageConnectionLinkLabel: 'Integrações',
      unlinkTooltip: 'Remove a conexão bancária desta conta.',
      recalculateDailyBalance: 'Recalcular saldo diário',
      syncPendingTransactions: 'Sincronizar pendências',
      syncPendingTransactionsRunning: 'Sincronizando...',
      syncPendingTransactionsTooltip:
        'Busca transações novas desde a última sincronização (incremental). Não refaz o histórico completo da conta.',
      syncPendingThenRecalculateTooltip:
        'Sincroniza transações novas (incremental) e, em seguida, recalcula o saldo ao final de cada dia no período do extrato.',
      syncPendingTransactionsSuccess:
        'Sincronização enfileirada. As movimentações serão atualizadas em breve.',
      syncPendingTransactionsError: 'Erro ao sincronizar. Tente novamente.',
      syncPlaidSuccess: 'Sincronização concluída.',
      syncPlaidNotReady: 'A conexão ainda está sendo preparada. Tente de novo em instantes.',
      periodRequiredForAction: 'Selecione um período antes de continuar.',
      integrationPermissionRequired: 'Você não tem permissão para gerenciar esta integração.',
      syncBannerFetchingTitle: 'Buscando movimentações no banco...',
      syncBannerWaitingTitle: 'Aguardando processamento das movimentações...',
      syncBannerFetchingBodyOpenFinance:
        'Estamos consultando o Open Finance. Não recarregue a página.',
      syncBannerFetchingBodyKamino: 'Estamos consultando o Kamino. Não recarregue a página.',
      syncBannerFetchingBodyGeneric: 'Sincronizando com a integração. Não recarregue a página.',
      syncBannerWaitingBody:
        'Os lançamentos foram baixados e estão sendo persistidos. O extrato será atualizado automaticamente em instantes.',
      recalculating: 'Recalculando...',
      recalculateSuccess: 'Saldo diário recalculado com sucesso',
      recalculateSuccessReverse: 'Saldo recalculado a partir do snapshot do banco',
      recalculateSuccessForward: 'Saldo recalculado somando as transações desde o saldo inicial',
      recalculateDailyBalanceTooltipSnapshot:
        'Reescreve os saldos diários ancorando no snapshot mais recente do banco e voltando no tempo. Atualiza também o "Último Saldo".',
      recalculateDailyBalanceTooltipForward:
        'Soma todas as transações a partir do saldo inicial. Sem snapshot externo, drift histórico pode aparecer no saldo atual.',
      recalculatePartialSuccess:
        'Saldo diário recalculado ({{filled}} preenchidos, {{failed}} falhas)',
      recalculateError: 'Erro ao recalcular saldo diário',
      initialBalanceAlertTitle: 'Saldo inicial não configurado',
      initialBalanceAlertDescription:
        'Para obter melhores resultados no cálculo do saldo diário, preencha o campo valor saldo inicial e data inicial na edição da conta.',
      initialBalanceAlertEdit: 'Ir para edição',
      initialBalanceAlertProceed: 'Recalcular mesmo assim',
      balanceHealthTitle: 'Análise consolidada dos saldos',
      lastBalanceVsStatementTitle: 'Saldo da conta e extrato em momentos diferentes',
      lastBalanceVsStatementBody:
        'Saldo atual (Visão geral): {{card}}. No extrato, fechamento do dia mais recente no período ({{date}}): {{statement}}. Diferença: {{diff}}. É situação frequente no Open Finance: o saldo pode atualizar antes do movimento aparecer na lista — use «Sincronizar pendências» (sincroniza e recalcula o extrato) ou aguarde o envio das transações pelo Open Finance.',
      snapshotVsTransactionsTitle: 'Saldo atual difere das movimentações importadas',
      snapshotVsTransactionsBody:
        'Saldo atual (Open Finance): {{snapshot}}. Com base nas movimentações importadas até {{lastTxDate}}, o saldo esperado seria {{implied}}. Diferença: {{diff}}. É comum o saldo atualizar antes de todas as transações chegarem — aguarde a próxima sincronização ou use «Sincronizar pendências».',
      kindDeclaredBadge: 'Declarado',
      kindDeclaredTooltip: 'Saldo autoritativo proveniente de {{source}}',
      balanceSourceLabels: {
        OPEN_FINANCE: 'Open Finance',
        RECONCILIATION: 'Conciliação',
        STATEMENT_IMPORT: 'Importação de extrato',
        MANUAL: 'Lançamento manual',
      },
      calculationDirectionLabels: {
        FORWARD: 'Projetado para frente',
        BACKWARD: 'Projetado para trás',
        ANCHORED: 'Ancorado',
      },
      snapshotDiffAria: 'Saldo informado pelo banco difere do saldo calculado',
      snapshotTooltipTitle: 'Comparação do saldo do dia',
      snapshotTooltipSource: 'Open Finance',
      calculatedBalanceLabel: 'Calculado pelas movimentações',
      snapshotTooltipDiffLabel: 'Diferença',
      balanceStatusVerifiedBadge: 'Verificado',
      balanceStatusVerifiedTooltip:
        'Este saldo foi confirmado pelo banco via Open Finance neste dia.',
      balanceStatusProjectedBadge: 'Projetado',
      balanceStatusProjectedTooltip:
        'Saldo calculado com base nas movimentações importadas. Ainda não há confirmação do banco via Open Finance para este dia.',
      balanceStatusDivergentTooltip:
        'Alguma movimentação pode ainda não ter chegado pelo Open Finance ou pode estar duplicada.',
    },
    actions: {
      edit: 'Editar',
    },
    overview: {
      bank: 'Banco',
      account: 'Conta',
      balance: 'Último Saldo',
      details: 'Detalhes da Conta',
      lastImport: 'Última importação',
      balanceUpdatedAt: 'Atualizado em {{date}}',
      balanceDivergenceTitle: 'Saldo divergente',
      balanceDivergenceBody:
        'O snapshot {{source}} ({{snapshot}}) difere do saldo conhecido ({{lastKnown}}) em {{diff}}.',
      balanceDivergenceRebaseHint:
        'Na aba Extrato: contas Open Finance — «Sincronizar pendências» (sincroniza e recalcula); demais — «Recalcular saldo diário». Com snapshot do banco, o extrato reancora os saldos e o «Último saldo» é atualizado, limpando este alerta.',
    },
    internalOps: {
      title: 'Operações Internas',
      empty: 'Nenhuma operação interna encontrada',
      total: '{{count}} operações',
      unknownPairedAccount: 'Não identificada',
      summary: {
        yield: 'Rendimentos',
        rescue: 'Resgates',
        application: 'Aplicações',
        netImpact: 'Impacto no Saldo',
      },
      types: {
        yield: 'Rendimento',
        rescue: 'Resgate',
        application: 'Aplicação',
        other: 'Outro',
      },
      filters: {
        allTypes: 'Todos os tipos',
        dateRange: 'Selecione o período',
      },
      table: {
        date: 'Data',
        description: 'Descrição',
        type: 'Tipo',
        amount: 'Valor',
        pairedAccount: 'Conta Origem/Destino',
        status: 'Status',
      },
      status: {
        reconciled: 'Conciliado',
        pending: 'Pendente',
      },
      pagination: {
        showing: 'Mostrando {{from}}-{{to}} de {{total}}',
        previous: 'Anterior',
        next: 'Próximo',
      },
    },
    transfers: {
      title: 'Transferências',
      empty: 'Nenhuma transferência encontrada',
      total: '{{count}} transferências',
      unknownCounterparty: 'Não identificada',
      summary: {
        sent: 'Enviadas',
        received: 'Recebidas',
        netTransfer: 'Saldo Líquido',
        sentCount: '{{count}} transferências',
        receivedCount: '{{count}} transferências',
      },
      direction: {
        sent: 'Enviada',
        received: 'Recebida',
      },
      filters: {
        allDirections: 'Todas as direções',
        allCounterparties: 'Todas as contas',
        dateRange: 'Selecione o período',
      },
      table: {
        date: 'Data',
        description: 'Descrição',
        direction: 'Direção',
        amount: 'Valor',
        method: 'Método',
        counterparty: 'Conta Origem/Destino',
        status: 'Status',
      },
      status: {
        reconciled: 'Conciliada',
        pending: 'Pendente',
      },
      pagination: {
        showing: 'Mostrando {{from}}-{{to}} de {{total}}',
        previous: 'Anterior',
        next: 'Próximo',
      },
    },
  },
  creditCard: {
    notFound: 'Cartão de crédito não encontrado',
    childCards: {
      usedCount_one: '{{count}} cartão identificado no histórico',
      usedCount_other: '{{count}} cartões identificados no histórico',
    },
    brands: {
      VISA: 'Visa',
      MASTERCARD: 'Mastercard',
      AMEX: 'American Express',
      ELO: 'Elo',
      HIPERCARD: 'Hipercard',
      DINERS: 'Diners Club',
      OTHER: 'Outro',
    },
    status: {
      ACTIVE: 'Ativo',
      INACTIVE: 'Inativo',
      CANCELLED: 'Cancelado',
      EXPIRED: 'Expirado',
    },
    metadata: {
      final: 'final',
      closingDay: 'Fecha dia {{day}}',
      dueDay: 'Vence dia {{day}}',
    },
    tabs: {
      overview: 'Visão Geral',
      statements: 'Faturas',
    },
    actions: {
      edit: 'Editar',
    },
    overview: {
      brand: 'Bandeira',
      titular: 'Titular',
      validity: 'Validade',
      limit: 'Limite',
      available: 'Disponível',
      details: 'Detalhes do Cartão',
      name: 'Nome',
      description: 'Descrição',
      entity: 'Entidade',
      closingDay: 'Dia de fechamento',
      dueDay: 'Dia de vencimento',
      isDefault: 'Cartão Padrão',
      openFinance: 'Conexão Open Finance',
      openFinanceDescription:
        'Este cartão está vinculado ao Open Finance Brasil para sincronização automática de faturas.',
    },
    statements: {
      periodLabel: 'Período',
      periodCustom: 'Personalizado',
      searchPlaceholder: 'Buscar descrição...',
      clearFilters: 'Limpar filtros',
      itemCount: '{{count}} lançamentos',
      noItemsFound: 'Nenhum lançamento encontrado.',
      emptyTime: '—',
      statusLabel: 'Status',
      loadError: 'Erro ao carregar faturas',
      itemsLoadError: 'Erro ao carregar lançamentos da fatura',
      collapseInvoice: 'Recolher fatura',
      expandInvoice: 'Expandir fatura',
      collapseTransactionsForDate: 'Recolher transações de {{date}}',
      expandTransactionsForDate: 'Expandir transações de {{date}}',
      invoiceSummary: 'Resumo consolidado da fatura',
      informedTotal: 'Total informado',
      calculatedTotal: 'Total calculado',
      divergence: 'Divergência',
      settlement: 'Liquidação',
      paidAmount: 'Pago',
      providerPaymentEvidence: 'Evidência de pagamento Pluggy',
      estimatedClosing: 'Estimado',
      incompleteAccess: 'O resumo não inclui cartões sem permissão de acesso.',
      subtotalsByCard: 'Subtotais por cartão',
      settlementStatus: {
        unlinked: 'Sem vínculo com contas a pagar',
        closed: 'Fechada, aguardando pagamento',
        partial: 'Parcialmente paga',
        paid: 'Paga',
      },
      itemKind: {
        purchase: 'Compra',
        refund: 'Estorno',
        statement_payment: 'Pagamento da fatura',
        unknown: 'Revisar tipo',
      },
      retry: 'Tentar novamente',
      empty: 'Nenhuma fatura no período',
      noItems: 'Nenhum lançamento nesta fatura',
      noCardAccount:
        'Este cartão não possui faturas vinculadas. Conecte via Open Finance ou importe faturas para visualizar transações.',
      periods: {
        last5: 'Últimos 5 dias',
        last30: 'Últimos 30 dias',
        thisMonth: 'Este mês',
        lastMonth: 'Mês passado',
        last90: 'Últimos 90 dias',
      },
      status: {
        all: 'Todos',
        open: 'Aberta',
        closed: 'Fechada',
        partial: 'Parcial',
        paid: 'Paga',
      },
      table: {
        closingDate: 'Fechamento',
        dueDate: 'Vencimento',
        total: 'Total',
        status: 'Status',
        date: 'Data',
        transactionCount: 'Transações',
        childCard: 'Cartão',
        merchant: 'Estabelecimento',
        amount: 'Valor',
      },
    },
  },
};

// The English catalog lives in its own module to keep each locale file readable.
export { reconciliationEn } from './reconciliation-en';
